import useAppQuery from 'hooks/useAppQuery';
import { SeasonalRuleDetail } from 'models/seasonality/SeasonalRule';
import { fetchSeasonalRuleDetail } from './fetchSeasonalRuleDetail';
import { SEASONAL_RULES_BASE_QUERY_KEY } from './seasonalRulesQuery';

interface Args {
  seasonalRuleUid?: string;
  enabled?: boolean;
}

const useFetchSeasonalRuleDetail = ({
  seasonalRuleUid,
  enabled = !!seasonalRuleUid,
}: Args) =>
  useAppQuery<SeasonalRuleDetail>({
    queryKey: [SEASONAL_RULES_BASE_QUERY_KEY, 'detail', seasonalRuleUid],
    queryFn: () => fetchSeasonalRuleDetail(seasonalRuleUid as string),
    enabled: enabled && !!seasonalRuleUid,
  });

export default useFetchSeasonalRuleDetail;
